import json from "./fleet.json";
import { Project } from "../../components/project";

import overview from "../../assets/fleet/fleet-overview.webp";
import login from "../../assets/fleet/fleet-login.webp";
import driving from "../../assets/fleet/fleet-driving.webp";
import playback from "../../assets/fleet/fleet-playback.webp";
import preference from "../../assets/fleet/fleet-preference.webp";
import report_1 from "../../assets/fleet/fleet-reports.webp";
import report_2 from "../../assets/fleet/fleet-report-2.webp";
import report_3 from "../../assets/fleet/fleet-report-3.webp";
import tags from "../../assets/fleet/fleet-tags.webp";
import devices from "../../assets/fleet/fleet-devices.webp";
import drivers from "../../assets/fleet/drivers.webp";
import { IoIosArrowForward } from "react-icons/io";

const imageMap = {
  overview,
  login,
  driving,
  playback,
  preference,
  report_1,
  report_2,
  report_3,
  tags,
  devices,
  drivers,
};

export const Fleet = () => {
  return (
    <div className="flex flex-col sm:items-start items-center text-primary gap-3 animate-fade-down animate-once animate-duration-1000 animate-delay-0 animate-ease-in-out animate-normal animate-fill-both">
      <Project json={json} imageMap={imageMap} />
      <div className="sm:text-[30px] text-[25px] font-[500] mt-3">
        Link to the project
      </div>
      <div className="flex justify-center gap-x-4 text-xl">
        <IoIosArrowForward className="text-secondary mt-1" />
        <a
          rel="noreferrer"
          href={"https://fleet.icsukltd.com/"}
          target="_blank"
          className="text-[16px] text-secondary hover:opacity-90"
        >
          Fleet Management System
        </a>
      </div>
    </div>
  );
};
